var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", eager: "", scrollable: "", "max-width": "600" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "secondary white--text" },
            [
              _c(
                "v-icon",
                { staticClass: "white--text", attrs: { left: "" } },
                [_vm._v("not_listed_location")]
              ),
              _vm._v("\n      Come funziona?\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { depressed: "", light: "", icon: "" },
                  on: { click: _vm.dismiss },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            {
              staticClass: "white",
              staticStyle: { height: "450px", "overflow-y": "auto" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-row-icon mr-3" }, [
                          _vm._v("1."),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("MODALITA' & OPZIONI"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "info-text" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { color: "text", left: "", small: "" },
                                },
                                [_vm._v("settings")]
                              ),
                              _vm._v(
                                " Scegli una\n                tra le 4 modalità d'asta (e personalizza le relative opzioni)\n              "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-row-icon mr-3" }, [
                          _vm._v("2."),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("SCEGLI IL TUO LAYOUT"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "info-text" },
                            [
                              _vm._v(
                                "\n                Trova la visuale più comoda per seguire l'asta: Tavolo o Panoramica."
                              ),
                              _c("br"),
                              _vm._v("\n                Usa il pulsante "),
                              _c(
                                "v-icon",
                                { attrs: { color: "text", small: "" } },
                                [_vm._v("view_module")]
                              ),
                              _vm._v(" / "),
                              _c(
                                "v-icon",
                                { attrs: { color: "text", small: "" } },
                                [_vm._v("view_module")]
                              ),
                              _vm._v(
                                "\n                nella barra in alto per provare la visuale che ti piace di piú.\n              "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-row-icon mr-3" }, [
                          _vm._v("3."),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("AVVIA / STOP"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "info-text" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { color: "text", left: "", small: "" },
                                },
                                [_vm._v("play_arrow")]
                              ),
                              _vm._v(
                                " Premi Avvia\n                per iniziare l'asta."
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  attrs: { color: "text", left: "", small: "" },
                                },
                                [_vm._v("stop")]
                              ),
                              _vm._v(
                                " Premi Stop per\n                annullare il round (e quindi riselezionare chi mettere\n                all'asta)\n                "
                              ),
                              _c("br"),
                              _vm._v(
                                '\n                PS: In modalitá "Admin Assegna", non essendoci timers, non é necessario "avviare" l\'asta.\n\n              '
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-row-icon mr-3" }, [
                          _vm._v("4."),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("ET VOILA'"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "info-text" },
                            [
                              _vm._v(
                                "\n                Asta Live ti guiderà in maniera intuitiva sugli step\n                successivi: "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("v-icon", { attrs: { color: "text" } }, [
                                _vm._v("chevron_right"),
                              ]),
                              _vm._v(
                                "\n                Se tocca a te fare qualche azione (fare offerta, scegliere\n                calciatore da mettere all'asta...) ti si apriranno popup\n                intuitivi."
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("v-icon", { attrs: { color: "text" } }, [
                                _vm._v("chevron_right"),
                              ]),
                              _vm._v(
                                "\n                Se non tocca a te, potrai seguire l'andamento dell'asta sul\n                tavolo."
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                Man mano che l'asta prosegue, Asta Live aggiornerà tutto in\n                tempo reale\n              "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.Config.STANDALONE
                        ? _c("div", { staticClass: "info-row" }, [
                            _c(
                              "div",
                              { staticClass: "info-row-icon" },
                              [
                                _c("v-icon", { attrs: { color: "text" } }, [
                                  _vm._v("download"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-content" }, [
                              _c("div", { staticClass: "info-title" }, [
                                _vm._v("DOWNLOAD ROSE"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v("Terminata l'asta scarica le rose"),
                              ]),
                            ]),
                          ])
                        : _c("div", { staticClass: "info-row" }, [
                            _c(
                              "div",
                              { staticClass: "info-row-icon" },
                              [
                                _c("v-icon", { attrs: { color: "text" } }, [
                                  _vm._v("save"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-content" }, [
                              _c("div", { staticClass: "info-title" }, [
                                _vm._v("SALVA ROSE"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(
                                  "\n                Terminata l'asta ricordati di salvare le rose o non saranno\n                visibili da app/sito.\n              "
                                ),
                              ]),
                            ]),
                          ]),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-4" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c(
                          "div",
                          { staticClass: "info-row-icon" },
                          [
                            _c("v-icon", { attrs: { color: "text" } }, [
                              _vm._v("check"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("PARTECIPANTI ONLINE / OFFLINE"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-text" }, [
                            _vm._v(
                              "\n                Ovviamente dovreste essere tutti online (pallino verde\n                sull'avatar) per uno svolgimento ottimale."
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                Se qualcuno risultasse offline (pallino rosso),\n                l'amministratore d'asta, cliccando sulla squadra sul tavolo,\n                può:"
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center my-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ma-2",
                                    attrs: { color: "text" },
                                  },
                                  [_vm._v("airline_stops")]
                                ),
                                _vm._v(
                                  '\n                  Forzarne un "Passo"\n                '
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center my-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ma-2",
                                    attrs: { color: "text" },
                                  },
                                  [_vm._v("person_remove")]
                                ),
                                _vm._v(
                                  "\n                  Escluderlo dall'asta (temporaneamente)."
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                  PS: Utile anche quando una squadra completa il\n                  ruolo in cui state ancora chiamando calciatori\n                "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center my-2" },
                              [
                                _vm._v(
                                  "\n                  Su alcuni dispositivi/browser puó capitare che una persona sia online ma gli altri la vedano col pallino rosso.\n                  Se la situazione persiste dite a tale persona di refreshare la pagina (o chiudere e riaprire Asta Live).\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c(
                          "div",
                          { staticClass: "info-row-icon" },
                          [
                            _c("v-icon", { attrs: { color: "error" } }, [
                              _vm._v("warning"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title error--text" }, [
                            _vm._v("IMPORTANTE"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "error--text" }, [
                            _vm._v(
                              "\n                  Asta Live necessita che l'amministratore d'asta (che, vi ricordiamo, non corrisponde necessariamente con l'" +
                                _vm._s(_vm.adminLegaDivisioneLabel) +
                                ")\n                  debba "
                            ),
                            _c("b", [
                              _vm._v("sempre essere online (pallino verde)"),
                            ]),
                            _vm._v(
                              " altrimenti\n                  l'asta a un certo punto si bloccherà. E' sempre possibile\n                  cambiare tale amministratore durante il corso dell'asta.\n              "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c(
                          "div",
                          { staticClass: "info-row-icon" },
                          [
                            _c("v-icon", { attrs: { color: "text" } }, [
                              _vm._v("forum"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-content" }, [
                          _c("div", { staticClass: "info-title" }, [
                            _vm._v("CHAT"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-text" }, [
                            _vm._v(
                              "\n                Usa la chat di Asta Live per animare l'asta durante il suo\n                svolgimento\n              "
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "text-center" },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", [_vm._v("BUON DIVERTIMENTO SU ASTA LIVE!")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("celebration"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }